import type { InvestorDescriptionProps } from "@/types/components/investor/investor-description";
import { useInView } from "@/hooks/reveal-in-view";
import { useRef, type FC } from "react";
import { ContentManager } from "../content-manager";
import NextImage from 'next/image';

export const InvestorDescription: FC<InvestorDescriptionProps> = ({ description }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
    
    return <section className="investorDescription">
        <div className="wrapper" ref={ref}>
        <div className="payallStoryHero--logoWithText">
          <NextImage
            src="/logo-short.svg"
            alt="Logo"
            width={59}
            height={72}
            className="payallStoryHero--logo"
          />
          <ContentManager
            content={description}
            className="payallStoryHero--description"
            style={{
              transform: isInView ? 'none' : `translateY(20px)`,
              opacity: isInView ? 1 : 0,
              transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
            }}
          />
        </div>
      </div>
    </section>
}